import axios from 'axios';

class Request {
    constructor({ baseURL, timeout }) {
        this.request = axios.create({
            baseURL,
            timeout,
            headers: {
                'Content-Type': 'application/json',
                // 'Access-Control-Allow-Origin': '*',
            },
        });
    }

    async get(url, params) {
        try {
            return await this.request.get(url).then((res) => res.data);
        } catch (error) {
            throw new Error('error: ', error);
        }
    }

    async post(url, body) {
        try {
            return await this.request.post(url, body).then((res) => res.data);
        } catch (error) {
            throw new Error('error: ', error);
        }
    }

    async makeRequest({ url, method, params = false }) {
        return Promise.race([this[method](url, params)]);
    }
}

export default Request;
